import { Component, ViewChild, OnInit, Output, ViewEncapsulation, Input, HostListener, EventEmitter, ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Repository, WindowRef } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';
import {
  Lists_loaikhoan, Lists_tieumuc, Lists_nguonkinhphi, Lists_danhmuckhoxangdau
  , Ultil_donvi
} from '../../../routes/menu'
import 'jquery'
import 'bootstrap'

import { DomSanitizer } from '@angular/platform-browser';
import { ModalComponent } from 'ng2-bs3-modal/ng2-bs3-modal';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

import * as CodeMirror from 'codemirror';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/css/css.js';
import 'codemirror/mode/htmlmixed/htmlmixed.js';



const swal = require('sweetalert');
@Component({
  selector: 'app-danhmuc-khoxangdauchitietedit',
  templateUrl: './khoxangdauchitietedit.component.html',
  //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./khoxangdauchitietedit.component.scss'],
  providers: [ListService, Repository, WindowRef],
  encapsulation: ViewEncapsulation.None
})


export class khoxangdauchitieteditComponent implements OnInit {
  
  public ngaybatdau: Date = null;
  public ngayketthuc: Date = null;
  inputhinhthucs: any =
    [{ Id: 0, Ten: 'Sử dụng nội bộ' }
      , { Id: 1, Ten: 'Cho thuê' }];

  inputtrangthais: any =
    [{ Id: 0, Ten: 'Hoạt động' }
      , { Id: 1, Ten: 'Kết thúc' }];
  inputhesos: any =
    [{ Id: 1, Ten: 'Nhập kho' }
      , { Id: -1, Ten: 'Xuất kho' }];

  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
  indLoading: boolean = false;
  phanbo: any = { HopDongs:[], TonKhos:[] };
  nhomdtid: string = null;
  

  @Output() save: EventEmitter<any> = new EventEmitter();

  public ngxCurrencyOptions = {
    prefix: '',
    thousands: '.',
    decimal: ',',
    precision: 0,
    allowNegative: false
  };

  comboSearchFn_DV(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ten.toLowerCase().indexOf(term) > -1;
  }
  constructor(private _dataService: ListService, public repo: Repository, private sanitizer: DomSanitizer) {


  }
  transformYourHtml(htmlTextWithStyle) {
    return this.sanitizer.bypassSecurityTrustHtml(htmlTextWithStyle);
  }
  ngOnInit(): void {
    //document.getElementById('target').classList.add('upload-dialog1');
    //document.getElementById('defaultfileupload').style.display = 'none';
  }
  public ngonngu(text: string) {
    return this.repo.NgonNgu(text);
  }
  ngAfterViewInit() {
    
  } 


  comboSearchFn(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ma.toLowerCase().indexOf(term) > -1 || item.Ten.toLowerCase().indexOf(term) > -1;
  }
  @ViewChild("mafocus", { static: false }) mafocus: ElementRef;
  bnguonkinhphi: boolean = false;
  public dviid: string;
  bledit: boolean = false;
  currentUser: any;
  
  
  comboSearchFn2(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ten.toLowerCase().indexOf(term) > -1;
  }
  loadDataInit(nhomdoituongid: string, id: string, donviid: string, phanbo: any) {
    
    this.dviid = donviid;
    this.phanbo = phanbo;

    if (this.phanbo == null) {
      this.phanbo = { HopDongs: [], TonKhos: [] };
    }

    var authlogin = localStorage.getItem('currentUser');
    if (authlogin) {
      let data = JSON.parse(authlogin);
      this.currentUser = data;
      var giatri = data.ds_quyen.filter(name => name.Id === Lists_danhmuckhoxangdau.id.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Them == true)
          this.quyen_them = true;
        else
          this.quyen_them = false;
        if (giatri[0].Sua == true)
          this.quyen_sua = true;
        else
          this.quyen_sua = false;
        if (giatri[0].Xoa == true)
          this.quyen_xoa = true;
        else
          this.quyen_xoa = false;
      }
    }
    setTimeout(() => {
      this.mafocus.nativeElement.focus();
    }, 500);
    
    
    this.ngaybatdau = null;
    this.ngayketthuc = null;

  }
  
  maxcot: number = 4;
  keyComBoPress(event: any, hang: number, cot: number, luoi: number) {
    if (event.which === 13) {
      cot = cot + 1;

      if (cot > this.maxcot) {
        hang = hang + 1;
        cot = 1;
        if (luoi === 1) {
          if (hang === this.phanbo.HopDongs.length) {
            this.AddRowNewHD(this.phanbo.HopDongs);
          }
        }
        if (luoi === 2) {
          if (hang === this.phanbo.TonKhos.length) {
            this.AddRowNewTK(this.phanbo.TonKhos);
          }
        }
        

      }

      //this.setComboFocus(hang, cot, luoi);
      //event.preventDefault();
    }
  }
  //setComboFocus(hang: number, cot: number, luoi: number) {
  //  var tencombo: string = hang + '_' + cot + '_' + luoi;
  //  var ketqua = false;

  //  this.slcombo.forEach(
  //    (question) => {
  //      if (question.labelForId === tencombo) {

  //        ketqua = true;
  //        question.focus();
  //      }
  //    }
  //  );

  //  if (ketqua === false) {
  //    this.divs.forEach(
  //      (div) => {

  //        if (div.nativeElement.id === tencombo) {
  //          ketqua = true;
  //          div.nativeElement.focus();
  //        }

  //      }
  //    );
  //  }
  //}

  deleterow_PB(index: string, luoi: number) {
    console.log(index);
    swal({
      title: 'Bạn muốn xóa dòng này phải không?',
      text: 'Dữ liệu xóa sẽ không phục hồi lại được!',
      icon: "warning",
      buttons: {
        cancel: {
          text: 'Hủy bỏ',
          value: false,
          visible: true,
        },
        confirm: {
          text: 'Đồng ý',
          value: true,
          visible: true,
          className: "bg-danger",
          closeModal: true
        }
      }
    })
      .then(willDelete => {
        if (willDelete) {
          if (luoi==1)
            this.phanbo.HopDongs.splice(index, 1);
          if (luoi == 2)
            this.phanbo.TonKhos.splice(index, 1);
        }
      });
  }

  RowNewClickCT(luoi: number) {
    if (luoi == 1)
      this.AddRowNewHD(this.phanbo.HopDongs);
    if (luoi == 2)
      this.AddRowNewTK(this.phanbo.TonKhos);
      
  }
  AddRowNewHD(ctiets: any) {
    var sp = 'bottom';
    if (ctiets.length > 9)
      sp = 'top'
    if (ctiets.length > 0) //trường hợp lớn hơn 1 thì copy dòng cuối
    {
      var row = ctiets[ctiets.length - 1];

      ctiets.push({
        showpopup: sp, Id: null, PhanBoId: null, SoHopDong: null
        , NgayBatDau: null, NgayKetThuc: null, GhiChu: null
      });
    }
    else {
      ctiets.push({
        showpopup: sp, Id: null, PhanBoId: null, SoHopDong: null
        , NgayBatDau: null, NgayKetThuc: null, GhiChu: null
      });

    }

  }

  AddRowNewTK(ctiets: any) {
    var sp = 'bottom';
    if (ctiets.length > 9)
      sp = 'top'
    if (ctiets.length > 0) //trường hợp lớn hơn 1 thì copy dòng cuối
    {
      var row = ctiets[ctiets.length - 1];

      ctiets.push({
        showpopup: sp, Id: null, PhanBoId: null, Ngay: null
        , SoLuong: null, HeSo: null, GhiChu: null
      });
    }
    else {
      ctiets.push({
        showpopup: sp, Id: null, PhanBoId: null, Ngay: null
        , SoLuong: null, HeSo: null, GhiChu: null
      });

    }

  }


  public closeModal() {
    this.save.emit(this.phanbo);
  }
  public saveproduct() {
    this.save.emit(this.phanbo);
  }

  


}

